/* 변경된 정책에 대해 동의 받는 페이지 */
import React, { Component } from 'react';
import { Button } from 'antd';
import { FormattedMessage, defineMessages,   injectIntl } from 'react-intl';
import { Parse } from 'parse';
import axios from 'axios';


import { notiFormForError } from '../components/notificationForm';
import PolicyModal from '../components/PolicyModal';


const messages = defineMessages({
  agreePolicy:{
    id:'CheckPolicy.noti.check',
    defaultMessage:'Please read and agree to the Terms and Conditions 📝'
  },
});

class CheckPolicy extends Component {

  constructor(props){
    super(props);
    this.state = {
      visible : true,
      isAgree : false
    };
  }

  render(){

    return (
      <PolicyModal
        visible = {this.state.visible}
        onCancelFunc = {() => {
          this.setState({visible: false});
          this.props.history.push('/');
        }}
        checkedFunc = {() => this.setState({isAgree:true})}
        unCheckedFunc = {() => this.setState({isAgree:false})}
        checkTitle = { <FormattedMessage id={'CheckPolicy.checkbox.title'} defaultMessage={'I have read the Terms and Conditions'}/> }
        footer = {
          <Button
            onClick={this.handleOnClick}
            style={{backgroundColor:'#5fffaf',border:'none', padding: '0px 20px', margin: '20px 30px 20px 0'}}>
            <FormattedMessage id={'CheckPolicy.agreeBtn'} defaultMessage={'Agree'}/>
          </Button>
        }
      />
    );
  }

  handleOnClick = () => {
    const { formatMessage, locale } = this.props.intl;

    if ( !this.state.isAgree){
      notiFormForError(locale, formatMessage(messages.agreePolicy));
    } else {
      //1. 현재 유저 구글 스프레드 시트에 저장.
      const formData = new FormData();

      const user = Parse.User.current();

      formData.append('userId', user.id);
      formData.append('email', user.getEmail());
      formData.append('date', new Date());
      formData.append('sessionToken',user.getSessionToken());

      axios.post(process.env.REACT_APP_RECORD_USERS, formData)
      .then(res => {
        console.log(res.data);

        this.setState({visible: false});
        this.props.history.push('/');
      })
      .catch(error => console.log(error));

    }
  }
}
  
CheckPolicy = injectIntl(CheckPolicy);

export default CheckPolicy;
